import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const CustomersPage = lazy(() => import('@/pages/customers'));

export const Route = createFileRoute('/customers')({
  component: function CustomersRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <CustomersPage />
      </Suspense>
    );
  },
});
